import ELEMENT from 'element-ui'
import store from '@/store'
import { setAxios } from "@cttq/pc-common-api";
import { logout } from "@cttq/pc-common-api"
setAxios(axios, ELEMENT.Notification);

axios.defaults.timeout = 60000;
// 检查 http status code
function checkStatus(res) {
  const { status, config } = res
  if (status >= 200 && status < 300) {
	// sensors.quick('autoTrack', {
	// 	z_event_id: 'success',
	// 	z_event_type: "接口请求",
	// 	z_reqUrl: config.url
	// });
    return res.data
  }
  ELEMENT.Notification.error({
    title: status,
    message: res
  })
  let error = new Error()
  error.name = status
  throw error
}
let reqUrl = "";
// 检查 response code
function checkCode(data) {
	if ( data.code === '0' || data.msgCode == '100' ) {
		return data
	} else if (data.code == '104' || data.msgCode == '104'){
		ELEMENT.Message.error({ message: data.message });
	} else if (data.code == '103' || data.msgCode == '103'){
		ELEMENT.Message.error({ message: '信息填写不完整' });
	}else if (data.code == '108' || data.msgCode == '108') {
		ELEMENT.Message.error({ message: '您没有此服务的操作权限' });
	} else if (data.code == '116' || data.msgCode == '116') {
		ELEMENT.Message.error({ message: '系统异常，请稍后重试' });
	} else if(data.msgCode =="login_validate_fail"){
		// let url = loginUrl+'/login?service='+baseUrl+routerBase
		// window.location.href = url;
		logout();
	} else if(data && data.msgCode =="not_company_code"){
		return data
	} else if(data && data.message){
		ELEMENT.Message.error({ message: data.message });
	}  else if(data && data.code == "excel_is_empty"){
		ELEMENT.Message.error({ message: data.message });
	} else {
		ELEMENT.Message.error({ message: "网络异常" });
	}

}

// 封装 axios
export default function request(params) {
  // 默认请求头
  const defaultHeaders = {
    'Content-Type': 'application/json',
    // 'X-Account-ID': store && store.state && store.state.user && store.state.user.account
  }
  // console.log("最后",params);
  if (params.url.indexOf('external-common') > -1) {
    axios.defaults.baseURL = process.env.VUE_APP_accountUrl;
  } else if( params.url.indexOf('crm') > -1){
	  axios.defaults.baseURL = process.env.VUE_APP_crmUrl;
  } else if( params.url.indexOf('pmp') > -1){
	  axios.defaults.baseURL = process.env.VUE_APP_pmpUrl;
  } else if(params.url.indexOf('org') > -1 || params.url.indexOf('/person/selPersonDetail') > -1){
    axios.defaults.baseURL = process.env.VUE_APP_orgUrl;
  } else if(params.url.indexOf('mm/') > -1){
    axios.defaults.baseURL = process.env.VUE_APP_mmUrl;
  }else if(params.url.indexOf('bpcNew') > -1 ){
	defaultHeaders.accessToken = store.state && store.state.user && store.state.user.token;
    axios.defaults.baseURL ="/";//调试接口
  }else {
    defaultHeaders.accessToken = store.state && store.state.user && store.state.user.token;
    axios.defaults.baseURL = process.env.VUE_APP_serverUrl;
    // axios.defaults.baseURL ="/";//调试接口
  }
  const nextParams = { ...params, headers: { ...defaultHeaders,...params.headers } }//
  reqUrl = `${axios.defaults.baseURL}${nextParams.url}`;
  return axios({ ...nextParams })
    .then(checkStatus)
    .then(checkCode)
    .catch(err => {
		// sensors.quick('autoTrack', {
		// 	z_event_id: 'failue',
		// 	z_event_type: "接口请求",
		// 	z_message: err.message,
		// 	z_reqUrl: reqUrl
		// });
		// TODO: 根据不同的http状态码，做相应的处理
		ELEMENT.Notification.error({
			title: 'catch error',
			message: `${err.name}: ${err.message}`
		})
    })
}
export function uploadfile(url, file,completeFlag){
	const formData = new FormData()
	formData.append("file", file);
	formData.append("configurationId",this.$store.state.init.initData.configurationId);
  if(completeFlag || completeFlag == 0){
    formData.append("completeFlag",completeFlag)
  }
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: url,
			data: formData,
			headers: { "Content-Type": "multipart/form-data"}
		}).then((res) => {
			if (res.data.msgCode == "template_error" || res.data.msgCode == "read_excel_error" ) {
				ELEMENT.Message.error({ message: res.data.message });
				return
			}else if (res.data.msgCode !== "100") {
				ELEMENT.Message.error({ message: "网络异常" });
				return
			}
			resolve(res.data)
		},(err) => {
			ELEMENT.Message.error(err)
		})
	})
}
